import { createContext, useContext } from 'react';
export const ErrorHandlerContext = createContext((error) => {
    // eslint-disable-next-line no-console
    console.error(error);
});
export function useErrorHandler() {
    return useContext(ErrorHandlerContext);
}
//# sourceMappingURL=error-handler.js.map